/* Blade Performance — Plate Builder
   Reads its data from #pbx-data (emitted by sections/plate-builder.liquid),
   renders the live plate, resolves the Shopify variant from the customer's
   choices, and adds plate + extras to the cart in one request.
   Everything geometric is in real millimetres against a 520x111mm plate. */
(function(){
  'use strict';
  var root = document.getElementById('pbx');
  var dataEl = document.getElementById('pbx-data');
  if(!root || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch(e){ return; }

  /* ---------- catalogue model ---------- */
  var FINISHES = [
    {id:'printed',       name:'Printed',       fam:'printed', sizes:[20,30,40,50,60,70,79]},
    {id:'printed-metro', name:'Printed Metro', fam:'printed', sizes:[20,30,40,50,60,70,79]},
    {id:'gel-standard',  name:'Standard Gel',  fam:'gel',     sizes:[79]},
    {id:'gel-retro',     name:'Retro Gel',     fam:'gel',     sizes:[40,50,60,70,79]},
    {id:'gel-metro',     name:'Metro Gel',     fam:'gel',     sizes:[40,50,60]},
    {id:'gel-carbon',    name:'Carbon Gel',    fam:'gel',     sizes:[50]},
    {id:'gel-glitter',   name:'Glitter Gel',   fam:'gel',     sizes:[50]}
  ];
  var TYPES = [
    {id:'single-yellow', name:'Single plate — yellow', short:'single yellow',       meta:'Rear plate on its own',    faces:['yellow'],          pair:false},
    {id:'single-white',  name:'Single plate — white',  short:'single white',        meta:'Front plate on its own',   faces:['white'],           pair:false},
    {id:'fb-uk',         name:'Front & back — UK',     short:'front & back UK',     meta:'White front, yellow rear', faces:['white','yellow'],  pair:true},
    {id:'fb-irl',        name:'Front & back — IRL',    short:'front & back IRL',    meta:'White front and rear',     faces:['white','white'],   pair:true},
    {id:'fb-yellow',     name:'Front & back — yellow', short:'front & back yellow', meta:'Yellow front and rear',    faces:['yellow','yellow'], pair:true}
  ];
  var TINTS = [
    {id:'none',   name:'No tint',     meta:'Standard finish',      addon:null},
    {id:'smoked', name:'Smoked tint', meta:'Even dark overlay',    addon:'tint_smoked'},
    {id:'faded',  name:'Faded tint',  meta:'Fades down the plate', addon:'tint_faded'}
  ];
  var EXTRAS = [
    {id:'pair',  name:'Add a second pair',      meta:'Same spec, pressed together', addon:'pair'},
    {id:'pads',  name:'12 premium sticky pads', meta:'Enough for both plates',      addon:'pads'},
    {id:'badge', name:'IRL badge',              meta:'Printed on the plate',        addon:'badge'}
  ];
  TINTS  = TINTS.filter(function(t){ return !t.addon || (D.addons && D.addons[t.addon]); });
  EXTRAS = EXTRAS.filter(function(e){ return D.addons && D.addons[e.addon]; });

  var GEO = {plateH:111, plateW:520, charW:50, charH:79, gap:11, groupGap:33, margin:11, borderInset:5, borderStroke:4, borderClear:6};
  var FULL_MM = 79;
  // Real press faces: their own widths and side bearings are the truth, so no
  // squeeze or invented spacing is applied. Charles Wright is listed ahead of
  // its file arriving — the moment assets/charles-wright.ttf exists, the
  // stand-in correction for the printed and standard gel finishes turns off.
  var PRESS_FONTS = ['METRO 50mm BM', 'Charles Wright'];

  /* ---------- variant resolution ---------- */
  function norm(s){ return String(s||'').toLowerCase(); }
  function typeKey(v){
    v = norm(v).replace(/&amp;/g,'&');
    if(v.indexOf('single') > -1) return v.indexOf('white') > -1 ? 'single-white' : 'single-yellow';
    if(v.indexOf('white & white') > -1 || v.indexOf('white and white') > -1) return 'fb-irl';
    if(v.indexOf('yellow & yellow') > -1 || v.indexOf('yellow and yellow') > -1) return 'fb-yellow';
    if(v.indexOf('white') > -1 && v.indexOf('yellow') > -1) return 'fb-uk';
    return null;
  }
  function borderKey(v){ v = norm(v); return (v.indexOf('yes') > -1 || v.indexOf('with') > -1) ? true : false; }

  var optNames = (D.options || []).map(norm);
  var iType = -1, iBorder = -1, iSize = -1;
  optNames.forEach(function(n, i){
    if(n.indexOf('plate type') > -1 || n === 'type') iType = i;
    if(n.indexOf('border') > -1) iBorder = i;
    if(n.indexOf('size') > -1) iSize = i;   // e.g. Printed Metro's "Size (mm)"
  });
  function sizeKey(v){ var n = parseInt(String(v||'').replace(/[^0-9]/g,''), 10); return isNaN(n) ? null : n; }
  // Map every variant onto our keys once.
  var VARIANTS = (D.variants || []).map(function(v){
    return {
      id: v.id, price: v.price, available: v.available !== false, title: v.title,
      type: iType > -1 ? typeKey(v.opts[iType]) : null,
      border: iBorder > -1 ? borderKey(v.opts[iBorder]) : false,
      size: iSize > -1 ? sizeKey(v.opts[iSize]) : null
    };
  });
  // Sizes that exist as variants on this product (Printed Metro carries a
  // Size option; the gel products do not). Used to keep the offered sizes
  // honest: never offer a size the product cannot actually be bought in.
  var VARIANT_SIZES = [];
  if(iSize > -1){
    VARIANTS.forEach(function(v){ if(v.size !== null && VARIANT_SIZES.indexOf(v.size) === -1) VARIANT_SIZES.push(v.size); });
    VARIANT_SIZES.sort(function(a,b){ return a-b; });
  }
  function findVariant(type, border, size){
    var i, v;
    var wantBorder = iBorder > -1 ? border : null;
    for(i=0;i<VARIANTS.length;i++){
      v = VARIANTS[i];
      if(v.type !== type) continue;
      if(wantBorder !== null && v.border !== wantBorder) continue;
      if(iSize > -1 && size !== undefined && size !== null && v.size !== size) continue;
      return v;
    }
    return null;
  }
  function typeOffered(type){ return VARIANTS.some(function(v){ return v.type === type; }); }
  var hasBorderOption = iBorder > -1;

  /* ---------- state ---------- */
  var finish = null;
  for(var f=0; f<FINISHES.length; f++) if(FINISHES[f].id === D.finish) finish = FINISHES[f];
  if(!finish) finish = FINISHES[2];

  // The sizes this page offers: the finish's set, intersected with the sizes
  // the product actually has variants for (when it has a Size option at all).
  // If the two share nothing, fall back to the product's own sizes rather
  // than offer something that cannot be added to the cart.
  var SIZES = finish.sizes.slice();
  if(VARIANT_SIZES.length){
    var both = SIZES.filter(function(s){ return VARIANT_SIZES.indexOf(s) > -1; });
    SIZES = both.length ? both : VARIANT_SIZES.slice();
  } else {
    // Size-specific products — "40mm Metro Gel Plates", "50mm Carbon Gel
    // Plates" — carry their size in the handle and have no Size option. Lock
    // to it, so a 40mm product can never leave with "Text size: 50mm" on it.
    var hm = /(?:^|-)(\d{2})mm(?:-|$)/.exec(String(D.handle || ''));
    if(hm) SIZES = [parseInt(hm[1], 10)];
  }

  // Finishes split across size-specific products (Metro Gel = 40mm, 50mm and
  // 60mm products) still show the whole size set: the other sizes are links
  // to their sibling products and carry the typed text across.
  var SIZE_LINKS = {}, SIZE_ROW = SIZES.slice();
  if(SIZES.length === 1 && D.sizeLinks && D.sizeLinks[finish.id]){
    var sl = D.sizeLinks[finish.id], k;
    for(k in sl){ if(sl.hasOwnProperty(k) && sl[k]){ var mm = parseInt(k,10); if(mm !== SIZES[0] && finish.sizes.indexOf(mm) > -1){ SIZE_LINKS[mm] = sl[k]; if(SIZE_ROW.indexOf(mm) === -1) SIZE_ROW.push(mm); } } }
    SIZE_ROW.sort(function(a,b){ return a-b; });
  }
  function sizeHref(mm){ var base = SIZE_LINKS[mm]; return state.text ? base + (base.indexOf('?')>-1?'&':'?') + 'text=' + encodeURIComponent(state.text) : base; }

  var state = {text:'', size:null, type:null, border:false, tint:'none', extras:{}};
  function defaultSize(){ return SIZES.indexOf(50) > -1 ? 50 : SIZES[0]; }
  state.size = defaultSize();
  for(var t=0;t<TYPES.length;t++){ if(typeOffered(TYPES[t].id)){ state.type = TYPES[t].id; break; } }
  if(!state.type) state.type = TYPES[0].id;

  var $ = function(id){ return document.getElementById(id); };
  var esc = function(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); };
  var money = function(pence){ return '£' + (pence/100).toFixed(2); };
  var typeOf = function(id){ for(var i=0;i<TYPES.length;i++) if(TYPES[i].id===id) return TYPES[i]; return TYPES[0]; };
  function currentMm(){ return state.size || FULL_MM; }
  function currentVariant(){ return findVariant(state.type, hasBorderOption ? state.border : false, state.size); }

  function total(){
    var v = currentVariant(), sum = v ? v.price : 0, i;
    for(i=0;i<TINTS.length;i++) if(TINTS[i].id === state.tint && TINTS[i].addon) sum += D.addons[TINTS[i].addon].price;
    for(i=0;i<EXTRAS.length;i++) if(state.extras[EXTRAS[i].id]) sum += D.addons[EXTRAS[i].addon].price;
    return sum;
  }

  /* ---------- rendering ---------- */
  function plateHTML(face, opts){
    opts = opts || {};
    var txt = state.text || 'YOUR REG';
    var cls = 'plate' + ((opts.border !== undefined ? opts.border : state.border) ? ' has-border' : '');
    return '<div class="' + cls + '" data-mm="' + (opts.mm || currentMm()) + '" data-face="' + face + '" data-style="' + (opts.style || finish.id) + '" data-tint="' + (opts.tint || state.tint) + '"' + (opts.fit ? ' data-fit="width"' : '') + '>' +
      '<span class="plate__chars' + (state.text ? '' : ' empty') + '">' + esc(txt) + '</span><span class="plate__tint"></span></div>';
  }

  function renderPreview(){
    var faces = typeOf(state.type).faces, html = '', i;
    for(i=0;i<faces.length;i++) html += plateHTML(faces[i]);
    $('pbx-plates').innerHTML = html;
    var bits = [finish.name, currentMm() + 'mm', typeOf(state.type).pair ? 'pair' : 'single'];
    $('pbx-spec').textContent = bits.join(' · ');
  }

  function renderFinishes(){
    var html = '', i, s, on, from;
    for(i=0;i<FINISHES.length;i++){
      s = FINISHES[i]; on = s.id === finish.id;
      from = D.fromPrices && D.fromPrices[s.fam] ? 'from ' + money(D.fromPrices[s.fam]) : '';
      // Product photo where the product has one; rendered swatch otherwise.
      var img = D.images && D.images[s.id];
      var visual = img
        ? '<img class="fin__img" src="' + esc(img) + '" alt="' + esc(s.name) + ' plates" loading="lazy" width="480" height="360">'
        : plateHTML('yellow', {style:s.id, mm:FULL_MM, tint:'none', border:false, fit:true});
      var inner = visual +
        '<span class="fin__name">' + s.name + '</span>' +
        '<span class="fin__foot"><span class="fin__price">' + from + '</span>' +
        // Every tile carries the same circle as the prototype; only the
        // current finish's is filled. The others are still links to their
        // own product page, carrying the typed text with them.
        (on ? '<span class="fin__tick">&#10003;</span>' : '<span class="fin__tick"></span>') + '</span>';
      if(on){
        html += '<button class="fin" type="button" aria-pressed="true">' + inner + '</button>';
      } else {
        var href = D.links && D.links[s.id] ? D.links[s.id] : null;
        if(!href) continue;
        html += '<a class="fin" href="' + esc(href) + '" data-finish-link="' + s.id + '" aria-pressed="false">' + inner + '</a>';
      }
    }
    $('pbx-finishes').innerHTML = html;
    updateFinishLinks();
  }
  function updateFinishLinks(){
    var links = root.querySelectorAll('a[data-finish-link]'), i, base;
    for(i=0;i<links.length;i++){
      base = D.links[links[i].getAttribute('data-finish-link')];
      links[i].setAttribute('href', state.text ? base + (base.indexOf('?')>-1?'&':'?') + 'text=' + encodeURIComponent(state.text) : base);
    }
  }

  function renderSizes(){
    var s = finish, html = '', i;
    if(SIZE_ROW.length === 1){
      $('pbx-sizedesc').innerHTML = s.name + ' is pressed at ' + SIZES[0] + 'mm only' + (SIZES[0] === FULL_MM ? ' &mdash; full size, the standard UK character height.' : '.');
    } else if(SIZES.length === 1){
      $('pbx-sizedesc').innerHTML = 'Height of the characters on ' + s.name + '. All sizes cost the same.';
    } else {
      $('pbx-sizedesc').innerHTML = 'Height of the characters on ' + s.name + '. 79mm is full size &mdash; the standard UK character height. All sizes cost the same.';
    }
    for(i=0;i<SIZE_ROW.length;i++){
      if(SIZE_LINKS[SIZE_ROW[i]]) html += '<a class="size" data-size-link="' + SIZE_ROW[i] + '" href="' + sizeHref(SIZE_ROW[i]).replace(/"/g,'&quot;') + '" aria-pressed="false">' + SIZE_ROW[i] + 'mm</a>';
      else html += '<button class="size" type="button" data-size="' + SIZE_ROW[i] + '" aria-pressed="' + (state.size===SIZE_ROW[i]) + '">' + SIZE_ROW[i] + 'mm</button>';
    }
    $('pbx-sizes').innerHTML = html;
  }

  function renderTypes(){
    var html = '', i, t, v, sw, k;
    for(i=0;i<TYPES.length;i++){
      t = TYPES[i];
      if(!typeOffered(t.id)) continue;
      v = findVariant(t.id, hasBorderOption ? state.border : false, state.size) || findVariant(t.id, false, state.size) || findVariant(t.id, true, state.size);
      sw = '';
      for(k=0;k<t.faces.length;k++) sw += '<span class="chipp ' + (t.faces[k]==='yellow'?'y':'w') + '"></span>';
      html += '<button class="row" type="button" data-type="' + t.id + '" aria-pressed="' + (t.id===state.type) + '">' +
        '<span class="row__swatch">' + sw + '</span>' +
        '<span class="row__body"><span class="row__name">' + t.name + '</span><span class="row__meta">' + t.meta + '</span></span>' +
        '<span class="row__price">' + (v ? money(v.price) : '') + '</span></button>';
    }
    $('pbx-types').innerHTML = html;
  }

  function renderBorders(){
    var step = $('pbx-borderstep');
    if(!hasBorderOption){ step.hidden = true; return; }
    step.hidden = false;
    var opts = [{v:false,n:'No border'},{v:true,n:'With border'}], html = '', i, o;
    for(i=0;i<opts.length;i++){
      o = opts[i];
      html += '<button class="opt" type="button" data-border="' + o.v + '" aria-pressed="' + (state.border===o.v) + '">' +
        plateHTML('yellow', {border:o.v, tint:'none'}) + '<span class="opt__name">' + o.n + '</span></button>';
    }
    $('pbx-borders').innerHTML = html;
  }

  function renderTints(){
    var step = $('pbx-tintstep');
    if(TINTS.length < 2){ step.hidden = true; return; }
    step.hidden = false;
    var html = '', i, t, p;
    for(i=0;i<TINTS.length;i++){
      t = TINTS[i]; p = t.addon ? D.addons[t.addon].price : 0;
      html += '<button class="row" type="button" data-tint="' + t.id + '" aria-pressed="' + (t.id===state.tint) + '">' +
        '<span class="row__body"><span class="row__name">' + t.name + '</span><span class="row__meta">' + t.meta + '</span></span>' +
        '<span class="row__price">' + (p ? '+' + money(p) : 'Included') + '</span><span class="row__tick">&#10003;</span></button>';
    }
    $('pbx-tints').innerHTML = html;
  }

  function renderExtras(){
    var step = $('pbx-extrastep');
    if(!EXTRAS.length){ step.hidden = true; return; }
    step.hidden = false;
    var html = '', i, e;
    for(i=0;i<EXTRAS.length;i++){
      e = EXTRAS[i];
      html += '<button class="row" type="button" data-extra="' + e.id + '" aria-pressed="' + (!!state.extras[e.id]) + '">' +
        '<span class="row__body"><span class="row__name">' + e.name + '</span><span class="row__meta">' + e.meta + '</span></span>' +
        '<span class="row__price">+' + money(D.addons[e.addon].price) + '</span><span class="row__tick">&#10003;</span></button>';
    }
    $('pbx-extras').innerHTML = html;
  }

  function renderRail(){
    var done = [!!state.text, true, true, true, Object.keys(state.extras).length>0];
    var bars = $('pbx-rail').children, i;
    for(i=0;i<bars.length;i++) bars[i].className = done[i] ? 'on' : '';
  }

  function makeLine(){
    var bits = [finish.name, currentMm() + 'mm', typeOf(state.type).short];
    if(hasBorderOption) bits.push(state.border ? 'with border' : 'no border');
    if(state.tint !== 'none') for(var i=0;i<TINTS.length;i++) if(TINTS[i].id===state.tint) bits.push(TINTS[i].name.toLowerCase());
    for(var j=0;j<EXTRAS.length;j++) if(state.extras[EXTRAS[j].id]) bits.push(EXTRAS[j].name.toLowerCase());
    return bits.join(' · ');
  }

  function renderFoot(){
    var v = currentVariant();
    $('pbx-total').textContent = money(total());
    var btn = $('pbx-add');
    if(!state.text){ btn.disabled = true; btn.textContent = 'Enter your reg'; }
    else if(!v){ btn.disabled = true; btn.textContent = 'Unavailable'; }
    else if(!v.available){ btn.disabled = true; btn.textContent = 'Sold out'; }
    else if(fitBlocked){ btn.disabled = true; btn.textContent = 'Won’t fit — shorten the text'; }
    else { btn.disabled = false; btn.textContent = 'Add to cart'; }
    if(!state.text) $('pbx-review').textContent = 'Type a registration to get started.';
    else $('pbx-review').innerHTML = 'We will make <b>' + esc(state.text) + '</b> &mdash; ' + esc(makeLine()) + '.';
  }

  function renderAll(){
    renderPreview(); renderFinishes(); renderSizes(); renderTypes();
    renderBorders(); renderTints(); renderExtras(); renderRail(); renderFoot();
    sizePlates();
  }

  /* ---------- geometry ---------- */
  var MEAS = {};
  function metrics(fontStr, ch){
    var key = fontStr + '|' + ch;
    if(MEAS[key] !== undefined) return MEAS[key];
    var out = {w:0, cap:0};
    try{
      var ctx = document.createElement('canvas').getContext('2d');
      ctx.font = fontStr;
      var m = ctx.measureText(ch);
      out.w = m.width; out.cap = m.actualBoundingBoxAscent || 0;
    }catch(err){}
    MEAS[key] = out; return out;
  }
  function fontStr(cs, px){ return (cs.fontStyle||'normal') + ' ' + (cs.fontWeight||'400') + ' ' + px + 'px ' + cs.fontFamily; }
  // True only when a press face named in the stack has actually LOADED.
  // Checking the name alone is wrong: Charles Wright sits first in the stack
  // before its file exists, and a 404'd face must keep the stand-in squeeze
  // on. document.fonts.check() also can't be used — it answers true when no
  // matching @font-face exists at all. So look for a loaded FontFace.
  function isPressFont(list){
    if(!document.fonts || !document.fonts.forEach) return false;
    for(var i=0;i<PRESS_FONTS.length;i++){
      if(list.indexOf(PRESS_FONTS[i]) === -1) continue;
      var name = PRESS_FONTS[i], loaded = false;
      document.fonts.forEach(function(f){ if(f.status === 'loaded' && String(f.family).replace(/["']/g,'') === name) loaded = true; });
      if(loaded) return true;
    }
    return false;
  }
  function runPx(text, fstr, gapPx, wordPx, sx){
    var spaces = (text.match(/ /g) || []).length;
    return (metrics(fstr, text).w + (gapPx * text.length) + (wordPx * spaces)) * sx;
  }
  function tuneGel(id, fs){
    var f = document.getElementById(id); if(!f || !fs) return;
    var blur = f.querySelector('feGaussianBlur'); if(blur) blur.setAttribute('stdDeviation', (fs*0.042).toFixed(2));
    var lights = f.querySelectorAll('feSpecularLighting');
    for(var i=0;i<lights.length;i++) lights[i].setAttribute('surfaceScale', (fs * (i===0?0.100:0.070)).toFixed(2));
  }

  function sizePlates(){
    var nodes = root.querySelectorAll('.plate'), fsBig = 0, fsSmall = 0, i;
    for(i=0;i<nodes.length;i++){
      var p = nodes[i], box = p.getBoundingClientRect(), h = box.height, w = box.width;
      if(!h) continue;
      var chars = p.querySelector('.plate__chars'); if(!chars) continue;
      var mm = parseFloat(p.getAttribute('data-mm')) || FULL_MM;
      var ppm = h / GEO.plateH;
      var cs = getComputedStyle(chars);
      var fitTile = p.getAttribute('data-fit') === 'width';

      if(!fitTile){
        var marginMm = p.classList.contains('has-border') ? GEO.borderInset + GEO.borderStroke + GEO.borderClear : GEO.margin;
        p.style.paddingLeft = p.style.paddingRight = (marginMm * ppm) + 'px';
      }

      var probe = metrics(fontStr(cs, 200), 'H');
      var capRatio = probe.cap ? probe.cap / 200 : 0.72;
      var fs = (mm * ppm) / capRatio;
      var fstr = fontStr(cs, fs);

      var sx = 1, gapPx = 0, wordPx = 0;
      if(!isPressFont(cs.fontFamily)){
        var adv = metrics(fstr, 'H').w;
        sx = adv ? (mm * (GEO.charW / GEO.charH) * ppm) / adv : 1;
        gapPx  = (mm * (GEO.gap / GEO.charH) * ppm) / sx;
        wordPx = Math.max(0, ((mm * ((GEO.groupGap - GEO.gap) / GEO.charH) * ppm) / sx) - metrics(fstr, ' ').w);
      }

      var txt = chars.textContent || '';
      var pcs = getComputedStyle(p);
      var innerW = p.clientWidth - parseFloat(pcs.paddingLeft||0) - parseFloat(pcs.paddingRight||0);
      var w0 = runPx(txt, fstr, gapPx, wordPx, sx);
      if(fitTile){
        if(w0 > innerW && w0 > 0){ var k = innerW / w0; fs *= k; gapPx *= k; wordPx *= k; }
      } else {
        p._needPx = w0; p._availPx = innerW; p._ppm = ppm;
      }

      chars.style.fontSize = fs + 'px';
      chars.style.transform = 'scaleX(' + sx.toFixed(4) + ')';
      chars.style.letterSpacing = gapPx + 'px';
      chars.style.wordSpacing = wordPx + 'px';
      p.style.setProperty('--pin', (GEO.borderInset * ppm) + 'px');
      p.style.setProperty('--pbw', Math.max(1.5, GEO.borderStroke * ppm) + 'px');

      if(p.closest('#pbx-plates')) fsBig = Math.max(fsBig, fs); else fsSmall = Math.max(fsSmall, fs);
    }
    tuneGel('pbx-gel-lg', fsBig); tuneGel('pbx-gel-sm', fsSmall);
    checkFit();
  }

  // fitBlocked: the text cannot be made at any size this product offers. It
  // gates Add to cart, so an unpressable order can never reach the bench.
  var fitBusy = false, dropNote = '', fitBlocked = false;
  function setBlocked(v){ if(fitBlocked !== v){ fitBlocked = v; renderFoot(); } }
  function checkFit(){
    var warn = $('pbx-fitwarn'), p = document.querySelector('#pbx-plates .plate');
    if(!warn) return;
    var btns = root.querySelectorAll('#pbx-sizes button'), lnks = root.querySelectorAll('#pbx-sizes a[data-size-link]'), i, s, ok;
    if(!state.text || !p || !p._availPx){
      warn.className = 'fitwarn'; warn.innerHTML = '';
      for(i=0;i<btns.length;i++){ btns[i].disabled = false; btns[i].removeAttribute('title'); }
      for(i=0;i<lnks.length;i++){ lnks[i].removeAttribute('aria-disabled'); lnks[i].removeAttribute('title'); }
      setBlocked(false);
      return;
    }
    var needMm = p._needPx / p._ppm, availMm = p._availPx / p._ppm, cur = currentMm();
    // A 520mm plate always gives well over 100mm of run. Anything less means the
    // preview was measured while hidden or mid-animation, so do not trust it.
    if(availMm < 100){
      warn.className = 'fitwarn'; warn.innerHTML = '';
      for(i=0;i<btns.length;i++){ btns[i].disabled = false; btns[i].removeAttribute('title'); }
      for(i=0;i<lnks.length;i++){ lnks[i].removeAttribute('aria-disabled'); lnks[i].removeAttribute('title'); }
      setBlocked(false);
      return;
    }
    var count = state.text.replace(/ /g,'').length, sizes = SIZES, largest = null;
    for(i=0;i<sizes.length;i++) if(needMm * (sizes[i]/cur) <= availMm + 0.5 && (largest===null || sizes[i] > largest)) largest = sizes[i];
    for(i=0;i<btns.length;i++){
      s = parseInt(btns[i].getAttribute('data-size'),10);
      ok = needMm * (s/cur) <= availMm + 0.5;
      btns[i].disabled = !ok;
      if(ok) btns[i].removeAttribute('title'); else btns[i].setAttribute('title', count + ' characters will not fit at ' + s + 'mm');
    }
    for(i=0;i<lnks.length;i++){
      s = parseInt(lnks[i].getAttribute('data-size-link'),10);
      ok = needMm * (s/cur) <= availMm + 0.5;
      if(ok){ lnks[i].removeAttribute('aria-disabled'); lnks[i].removeAttribute('title'); }
      else { lnks[i].setAttribute('aria-disabled','true'); lnks[i].setAttribute('title', count + ' characters will not fit at ' + s + 'mm'); }
    }
    if(needMm <= availMm + 0.5){
      if(dropNote){ warn.className = 'fitwarn show'; warn.innerHTML = dropNote; } else { warn.className = 'fitwarn'; warn.innerHTML = ''; }
      setBlocked(false);
      return;
    }
    if(largest !== null && !fitBusy){
      dropNote = 'Dropped to ' + largest + 'mm &mdash; ' + count + ' characters will not fit at ' + cur + 'mm on a 520mm plate.';
      fitBusy = true; state.size = largest; renderAll(); fitBusy = false; return;
    }
    warn.className = 'fitwarn show';
    warn.innerHTML = count + ' characters at ' + cur + 'mm needs ' + Math.round(needMm) + 'mm &mdash; a 520mm plate gives you ' + Math.round(availMm) + 'mm. Shorten the text.';
    setBlocked(true);
  }

  /* ---------- cart ---------- */
  function spec(){
    return ['v1', state.text, finish.id, currentMm(), state.type, hasBorderOption ? (state.border?'b1':'b0') : 'b-', state.tint].join('|');
  }
  function addToCart(){
    var v = currentVariant(); if(!v || !state.text) return;
    var btn = $('pbx-add'); if(btn.classList.contains('busy')) return;
    btn.classList.add('busy'); btn.textContent = 'Adding…';

    var props = {
      'Make': state.text + ' · ' + makeLine(),
      'Plate Text': state.text,
      'Plates': typeOf(state.type).name.replace(' — ', ' — ') + ' (' + typeOf(state.type).meta.toLowerCase() + ')',
      'Finish': finish.name,
      'Text size': currentMm() + 'mm'
    };
    if(hasBorderOption) props['Border'] = state.border ? 'With border' : 'No border';
    for(var i=0;i<TINTS.length;i++) if(TINTS[i].id===state.tint && TINTS[i].addon) props['Tint'] = TINTS[i].name.replace(' tint','');
    props['_spec'] = spec();

    // Add-ons go in first and the plate last: the cart drawer lists newest
    // first, so the plate line ends up on top with its add-ons beneath it.
    var items = [];
    for(var e=EXTRAS.length-1;e>=0;e--) if(state.extras[EXTRAS[e].id])
      items.push({ id: D.addons[EXTRAS[e].addon].id, quantity: 1, properties: { 'For plate': state.text } });
    for(var t=0;t<TINTS.length;t++) if(TINTS[t].id===state.tint && TINTS[t].addon)
      items.push({ id: D.addons[TINTS[t].addon].id, quantity: 1, properties: { 'For plate': state.text } });
    items.push({ id: v.id, quantity: 1, properties: props });

    fetch((D.routes && D.routes.cart_add_url ? D.routes.cart_add_url : '/cart/add') + '.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items: items })
    }).then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
      .then(function(res){
        if(!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to cart');
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        document.dispatchEvent(new CustomEvent('cart:build', {bubbles:true}));
        var tg = document.getElementById('cart-drawer-toggle'); if(tg) tg.click();
        toast('Added — ' + money(total()) + ', plate text attached.');
      })
      .catch(function(err){ toast(err.message || 'Could not add to cart. Please try again.'); })
      .then(function(){ btn.classList.remove('busy'); renderFoot(); });
  }
  var toastT;
  function toast(msg){
    var t = $('pbx-toast'); if(!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function(){ t.classList.remove('show'); }, 3200);
  }

  /* ---------- events ---------- */
  var reg = $('pbx-reg');
  function applyText(raw){
    var v = String(raw||'').toUpperCase().replace(/[^A-Z0-9 ]/g,'').slice(0,9);
    reg.value = v; state.text = v.trim();
    $('pbx-count').textContent = v.length + '/9';
    var h = $('pbx-hint');
    if(v.length >= 9){ h.className = 'hint warn'; $('pbx-hinttext').textContent = 'That is the maximum nine characters.'; }
    else { h.className = 'hint'; $('pbx-hinttext').textContent = 'Up to 9 characters. Spacing is yours — these are show plates.'; }
  }
  reg.addEventListener('input', function(e){ dropNote = ''; applyText(e.target.value); renderAll(); });

  root.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('button') : null;
    if(!b || !root.contains(b)) return;
    if(b.getAttribute('data-size')){ dropNote=''; state.size = parseInt(b.getAttribute('data-size'),10); renderAll(); }
    else if(b.getAttribute('data-type')){ dropNote=''; state.type = b.getAttribute('data-type'); renderAll(); }
    else if(b.getAttribute('data-border')){ dropNote=''; state.border = b.getAttribute('data-border') === 'true'; renderAll(); }
    else if(b.getAttribute('data-tint')){ dropNote=''; state.tint = b.getAttribute('data-tint'); renderAll(); }
    else if(b.getAttribute('data-extra')){ dropNote=''; var k=b.getAttribute('data-extra'); if(state.extras[k]) delete state.extras[k]; else state.extras[k]=true; renderAll(); }
    else if(b.id === 'pbx-add' && !b.disabled){ addToCart(); }
  });

  // Keep the pinned preview under whatever the theme's sticky header measures.
  function setHeaderOffset(){
    var hdr = document.querySelector('.shopify-section-group-header-group, #shopify-section-header, .site-header');
    var h = hdr ? hdr.getBoundingClientRect().height : 60;
    root.style.setProperty('--header-h', Math.round(h) + 'px');
    var cta = root.querySelector('.cta');
    if(cta){ var ch = cta.getBoundingClientRect().height; if(ch > 0) document.body.style.paddingBottom = Math.round(ch + 12) + 'px'; }
  }

  // Prefill from ?text= (homepage strip / finish links carry it), or from a
  // value the browser restored.
  (function init(){
    var q = null;
    try { q = new URLSearchParams(location.search).get('text'); } catch(err){}
    applyText(q || reg.value || '');
    setHeaderOffset();
    renderAll();
  })();
  window.addEventListener('resize', function(){ setHeaderOffset(); sizePlates(); });
  if(document.fonts){
    if(document.fonts.ready) document.fonts.ready.then(function(){ MEAS = {}; sizePlates(); });
    if(document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function(){ MEAS = {}; sizePlates(); });
  }
})();
